var _path, _path2, _path3, _path4, _rect, _circle, _ellipse, _circle2, _g, _path5, _circle3, _g2, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 181,
    viewBox: "0 0 133 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Award 1",
    filter: "url(#filter0_d_3333_31295)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M22.5312 83.9785H99.1796V169.239L60.8554 144.217L22.5312 169.239V83.9785Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 28",
    d: "M22.5312 75.6758H99.1796V160.936L60.8554 135.914L22.5312 160.936V75.6758Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M99.1789 169.239V83.9785H93.1504V165.303L99.1789 169.239Z",
    fill: "#CE4444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 27",
    d: "M22.5301 169.239V83.9785H28.5586V165.303L22.5301 169.239Z",
    fill: "#CE4444"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40",
    x: 22.5312,
    y: 91.1777,
    width: 76.6483,
    height: 55.9791,
    fill: "url(#paint0_linear_3333_31295)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 60.8546,
    cy: 61.4659,
    r: 59.3546,
    fill: "#FFDE69",
    stroke: "#6E5600"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 61.1773,
    cy: 61.859,
    rx: 44.7398,
    ry: 44.4703,
    fill: "#9C7A01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_31295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 91,
    height: 91
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 63.3476,
    cy: 66.5195,
    r: 44.6621,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_31295)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 60.9687,
    cy: 61.7617,
    r: 44.6621,
    fill: "#C09525"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M61.2852 109.235C87.842 109.235 109.484 88.1029 109.484 61.8967C109.484 35.6905 87.842 14.5588 61.2852 14.5588C34.7285 14.5588 13.0862 35.6905 13.0862 61.8967C13.0862 88.1029 34.7285 109.235 61.2852 109.235Z",
    fill: "#6F5600",
    stroke: "#D1A635",
    strokeWidth: 6.83155
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3333_31295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 90,
    height: 90
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_2",
    cx: 63.3257,
    cy: 66.4761,
    r: 44.5093,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3333_31295)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3_3",
    cx: 60.9546,
    cy: 61.7359,
    r: 44.5093,
    fill: "#936A00"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M61.2844 27.0781L72.4492 49.1418L72.6898 49.6174L73.2188 49.6827L95.4254 52.4255L80.1548 69.3455L79.8297 69.7057L79.9115 70.184L84.0821 94.5785L61.7273 83.5342L61.2844 83.3154L60.8415 83.5342L38.4899 94.577L42.6973 70.1854L42.78 69.7056L42.4534 69.3446L27.1462 52.4252L49.3499 49.6827L49.879 49.6174L50.1196 49.1418L61.2844 27.0781Z",
    fill: "url(#paint1_linear_3333_31295)",
    stroke: "#7E6200",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3333_31295",
    x: 0.216502,
    y: 0.82783,
    width: 132.245,
    height: 180.163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3333_31295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3333_31295",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_31295",
    x1: 60.8554,
    y1: 91.1777,
    x2: 60.8554,
    y2: 147.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#983535",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3333_31295",
    x1: 61.2844,
    y1: 24.8633,
    x2: 61.2844,
    y2: 96.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE178"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMessage);
export default __webpack_public_path__ + "static/media/First_Message.41bc9471b31fa80322a7c11a921f6b03.svg";
export { ForwardRef as ReactComponent };